/* eslint-disable simple-import-sort/imports */
import PropTypes from 'prop-types';
import React from 'react';
import { styled } from 'styled-components';

const StyledButton = styled.button`
  font-family: 'Hanken Grotesk', sans-serif;
  display: flex;
  padding: clamp(0.5rem, 1.064vw + 0.181rem, 1rem)
    clamp(1.125rem, 2.527vw + 0.367rem, 2.313rem);
  justify-content: center;
  align-items: center;
  font-size: clamp(0.563rem, 1.25vw + 0.188rem, 1.125rem);
  font-weight: 700;
  line-height: 160%;
  letter-spacing: 0.02em;
  border-radius: 55px;
  white-space: nowrap;
  width: max-content;
  height: 100%;
  max-height: 61px;
  min-height: 45px;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.defaultWhite};
  transition: all ${({ theme }) => theme.constant.transition};

  ${({ $blue, theme }) =>
    $blue &&
    ` 
		background-color: ${theme.colors.secondary};	
		color: ${theme.colors.defaultWhite};
    font-size: 18px;

  @media (max-width: ${theme.breakpoint.mobile}) {
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
    }
	`};

  ${({ $smallBlue, theme }) =>
    $smallBlue &&
    ` 
		background-color: ${theme.colors.backgroundLight};	
		color: ${theme.colors.gray600};
    padding: 8px 30px;
    font-size: 18px;
    line-height: 100%;
    font-weight: 500;
    text-transform: none;
    border-radius: 55px;
    letter-spacing: 0px;
    min-height: 36px;
	`};

  ${({ $onlyBorder, theme }) =>
    $onlyBorder &&
    ` 
	  display: flex;
	 	align-items:center;
		justify-content: center;
	 	font-size: 14px;
	  border-radius: 8px;
		background: transparent;
		border: 1px solid ${theme.colors.secondary};
		color: ${theme.colors.defaultText};
		min-width: 110px;
		max-height:32px;
		min-height:32px;
		background: rgba(255, 255, 255, 0.50);
		text-transform: none;
		
		&:hover,&:active{
			background:#d7e7f6;
		}
	`};

  &:hover,
  &:visited {
    opacity: 80%;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.smallMobile}) {
    font-size: 15px;
    white-space: normal;
  }
`;

const Button = ({
  children,
  orange,
  darkText,
  blue,
  smallBlue,
  onlyBorder,
  ...rest
}) => {
  return (
    <StyledButton
      $orange={orange}
      $darkText={darkText}
      $blue={blue}
      $smallBlue={smallBlue}
      $onlyBorder={onlyBorder}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  orange: PropTypes.bool,
  darkText: PropTypes.bool,
  blue: PropTypes.bool,
  smallBlue: PropTypes.bool,
  onlyBorder: PropTypes.bool,
};

export default Button;
